import { render, staticRenderFns } from "./insurance_reciept_reprint.vue?vue&type=template&id=db2b1806&scoped=true&"
import script from "./insurance_reciept_reprint.vue?vue&type=script&lang=js&"
export * from "./insurance_reciept_reprint.vue?vue&type=script&lang=js&"
import style0 from "./insurance_reciept_reprint.vue?vue&type=style&index=0&id=db2b1806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2b1806",
  null
  
)

export default component.exports